import React, { useState, useEffect, memo } from 'react';

import { ContactListStore } from '../store';
import { Modal, Alert } from 'antd';

import { runInAction } from 'mobx';
import _ from 'lodash';
import { MOpNameDisplayContainer } from '@/components';
import { tryRefresh } from '@/utils';

export const ActionMDelete: React.FC<{
    defaultStore: ContactListStore;
}> = ({ defaultStore }) => {
    const { defaultMSelect } = defaultStore;
    const { mSeletedData } = defaultMSelect;
    const [loading, setLoading] = useState<boolean>(false);
    if (mSeletedData === null || mSeletedData.length === 0) {
        return null;
    }
    const visible = defaultStore.actionType === 'm-delete';
    return (
        <Modal
            visible={visible}
            title={'批量删除线索'}
            onCancel={() => {
                defaultStore.resetAction();
            }}
            confirmLoading={loading}
            onOk={async () => {
                setLoading(true);
                const ok = await defaultStore.mdelete();
                setLoading(false);

                if (ok) {
                    runInAction(() => {
                        defaultStore.resetAction();
                        defaultMSelect.removeAllSelectedData();
                        tryRefresh(['contacts']);
                    });
                }
            }}
        >
            <h4>
                是否将选择的{mSeletedData.length}个线索删除？
                <MOpNameDisplayContainer
                    defaultStore={defaultStore}
                    nameParam="name"
                />
            </h4>
            <Alert type="error" message="删除成功之后，该操作无法恢复。" />
        </Modal>
    );
};
